import React, { useState, useEffect } from 'react';
import { Input, Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import './styles/ModalTaskFilters.css';

// Estilos inline para aplicação imediata
const mobileStyles = {
  filterContainer: {
    width: '100%'
  },
  filterRow: {
    display: 'flex',
    flexDirection: window.innerWidth <= 767 ? 'column' : 'row',
    alignItems: window.innerWidth <= 767 ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    flexWrap: window.innerWidth <= 767 ? 'wrap' : 'nowrap'
  },
  filterLeft: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: window.innerWidth <= 767 ? '10px' : '0',
    alignItems: 'center'
  },
  filterButton: {
    marginRight: '8px',
    marginBottom: window.innerWidth <= 767 ? '8px' : '0'
  },
  actionRight: {
    display: 'flex',
    flexWrap: window.innerWidth <= 767 ? 'wrap' : 'nowrap',
    marginTop: window.innerWidth <= 767 ? '5px' : '0'
  },
  teacherButtons: {
    display: 'flex',
    flexWrap: window.innerWidth <= 767 ? 'wrap' : 'nowrap',
  },
  teacherButton: {
    marginLeft: window.innerWidth <= 767 ? '0' : '8px',
    marginRight: window.innerWidth <= 767 ? '8px' : '0',
    marginBottom: window.innerWidth <= 767 ? '8px' : '0'
  },
  buttonText: {
    display: window.innerWidth <= 375 ? 'none' : 'inline'
  },
  buttonIcon: {
    marginRight: window.innerWidth <= 375 ? '0' : '4px'
  }
};

export const ModalTaskFilters = ({ 
    showFilters, 
    selectedUnit, 
    selectedLesson,
    units,
    lessons,
    onUnitChange,
    onLessonChange,
    onToggleFilters,
    onToggleShowAll,
    showAllInfo,
    isTeacher,
    onNewTask,
    onShowTemplates,
    onShowUserTasks,
    translate,
    searchQuery,
    onSearch,
    assignedOnly,
    onToggleAssignedOnly,
    participants,
    assignedUserFilter,
    onAssignedUserChange,
    canCreate,
    canEdit,
    canDelete
}) => {
    // Estado para controlar o dropdown de opções móveis
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    
    // Toggle para o dropdown de opções móveis
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <div className="mb-4 modal-task-filters-container">
            {/* Versão para telas grandes (desktop/tablet) */}
            <div className="desktop-filters">
                <div className="d-flex justify-content-between align-items-center filters-row">
                    <div className="d-flex align-items-center filter-buttons-left">
                    <div className="dropdown mr-3">
                        <button
                            className="btn btn-sm btn-secondary dropdown-toggle"
                            type="button"
                            onClick={onToggleFilters}
                        >
                            <i className="fas fa-filter mr-1"></i>
                            {translate?.filtros || "Filtros"}
                        </button>
                        
            {showFilters && (
                <div className="dropdown-menu show filter-dropdown-menu p-2" style={{ maxWidth: '320px', overflow: 'auto' }}>
                                <div className="mb-2">
                                    <label className="form-control-label d-flex align-items-center small">
                                        <i className="ni ni-building mr-2"></i>
                                        Unit
                                    </label>
                                    <Input
                                        type="select"
                                        value={selectedUnit}
                                        onChange={onUnitChange}
                                        className="form-control-alternative form-control-sm"
                                        bsSize="sm"
                                    >
                                        <option value="">Todas as Units</option>
                                        {units.map(unit => (
                                            <option key={unit.id} value={unit.id}>
                                                {unit.name}
                                            </option>
                                        ))}
                                    </Input>
                                </div>

                                <div className="mb-2">
                                    <label className="form-control-label d-flex align-items-center small mb-1">
                                        <i className="ni ni-single-02 mr-2"></i>
                                        Atribuídas
                                    </label>
                                    <div className="form-check d-flex align-items-center">
                                        <Input type="checkbox" className="form-check-input mr-2" checked={!!assignedOnly} onChange={onToggleAssignedOnly} id="assignedOnlyCheck" />
                                        <label className="form-check-label small text-muted" htmlFor="assignedOnlyCheck">Mostrar somente tarefas designadas</label>
                                    </div>
                                </div>

                                {assignedOnly && (
                                    <div className="mb-2">
                                        <label className="form-control-label d-flex align-items-center small">
                                            <i className="ni ni-circle-08 mr-2"></i>
                                            Usuário
                                        </label>
                                        <Input type="select" value={assignedUserFilter} onChange={onAssignedUserChange} className="form-control-alternative form-control-sm" bsSize="sm">
                                            <option value="">Todos</option>
                                            {participants.map(p => (
                                                <option key={p.id} value={p.id}>{p.name || p.email || p.id}</option>
                                            ))}
                                        </Input>
                                    </div>
                                )}
                                
                                <div className="mb-2">
                                    <label className="form-control-label d-flex align-items-center small">
                                        <i className="ni ni-book-bookmark mr-2"></i>
                                        Lesson
                                    </label>
                                    <Input
                                        type="select"
                                        value={selectedLesson}
                                        onChange={onLessonChange}
                                        className="form-control-alternative form-control-sm"
                                        bsSize="sm"
                                        disabled={!selectedUnit}
                                    >
                                        <option value="">Todas as Lessons</option>
                                        {lessons.map(lesson => (
                                            <option key={lesson.id} value={lesson.id}>
                                                {lesson.name}
                                            </option>
                                        ))}
                                    </Input>
                                </div>

                                {(selectedUnit || selectedLesson) && (
                                    <Button
                                        color="link"
                                        size="sm"
                                        className="text-muted p-0 small"
                                        onClick={() => {
                                            onUnitChange({ target: { value: '' } });
                                            onLessonChange({ target: { value: '' } });
                                        }}
                                    >
                                        <i className="fas fa-times mr-1"></i>
                                        Limpar filtros
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>

                    <button
                        className={`btn btn-sm ${showAllInfo ? 'btn-primary' : 'btn-outline-primary'} mr-3`}
                        onClick={onToggleShowAll}
                    >
                        <i className={`fas fa-${showAllInfo ? 'compress-alt' : 'expand-alt'} mr-1`}></i>
                        {showAllInfo ? 'Mostrar menos' : 'Mostrar mais'}
                    </button>

                    {(selectedUnit || selectedLesson) && (
                            <div className="d-flex align-items-center filter-tags">
                            {selectedUnit && (
                                <span className="badge badge-primary badge-sm mr-2">
                                    <i className="ni ni-building mr-1"></i>
                                    {units.find(u => u.id === parseInt(selectedUnit))?.name}
                                </span>
                            )}
                            {selectedLesson && (
                                <span className="badge badge-info badge-sm">
                                    <i className="ni ni-book-bookmark mr-1"></i>
                                    {lessons.find(l => l.id === parseInt(selectedLesson))?.name}
                                </span>
                            )}
                        </div>
                    )}
                </div>

                    <div className="action-buttons-right">
                    {isTeacher ? (
                            <div className="d-flex teacher-buttons">
                                {canCreate && (
                            <button 
                                onClick={onNewTask}
                                className="btn btn-primary btn-sm"
                            >
                                        <i className="fas fa-plus mr-1"></i> 
                                        {translate?.nova_tarefa || "Nova Tarefa"}
                            </button>
                                )}
                            
                            <button
                                className="btn btn-primary btn-sm ml-2"
                                onClick={onShowTemplates}
                            >
                                    <i className="fas fa-copy mr-1"></i> 
                                    {translate?.usar_template || "Usar Template"}
                            </button>
                        </div>
                    ) : (
                        <button 
                            onClick={onShowUserTasks}
                            className="btn btn-primary btn-sm"
                        >
                                <i className="fas fa-tasks mr-1"></i> 
                                Minhas tarefas enviadas
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Versão para celular (mobile) */}
            <div className="mobile-filters">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Dropdown agora posicionado à esquerda (primeiro elemento) */}
                    <div className="dropdown mobile-menu-dropdown">
                        <button
                            className="btn btn-primary btn-sm dropdown-toggle"
                            type="button"
                            onClick={toggleMobileMenu}
                            id="mobileMenuButton"
                        >
                            <i className="fas fa-bars mr-1"></i> Menu
                        </button>
                        
                        {mobileMenuOpen && (
                            <div className="dropdown-menu dropdown-menu-left show">
                                {/* Filtros */}
                                <h6 className="dropdown-header">Filtros</h6>
                                <button className="dropdown-item" type="button" onClick={onToggleFilters}>
                                    <i className="fas fa-filter mr-2"></i> 
                                    {translate?.filtros || "Filtros"}
                                </button>
                                <button className="dropdown-item" type="button" onClick={onToggleShowAll}>
                                    <i className={`fas fa-${showAllInfo ? 'compress-alt' : 'expand-alt'} mr-2`}></i>
                                    {showAllInfo ? 'Mostrar menos' : 'Mostrar mais'}
                                </button>
                                
                                <div className="dropdown-divider"></div>
                                
                                {/* Ações */}
                                <div className="dropdown-divider"></div>
                                <div className="px-3 py-2">
                                    <div className="form-group mb-2">
                                        <div className="form-check">
                                            <Input type="checkbox" className="form-check-input" id="mobileAssignedOnly" checked={!!assignedOnly} onChange={onToggleAssignedOnly} />
                                            <label className="form-check-label small" htmlFor="mobileAssignedOnly">Mostrar somente tarefas designadas</label>
                                        </div>
                                    </div>

                                    {assignedOnly && (
                                        <div className="form-group">
                                            <label className="small">Usuário</label>
                                            <Input type="select" value={assignedUserFilter} onChange={onAssignedUserChange} className="form-control form-control-sm">
                                                <option value="">Todos</option>
                                                {participants.map(p => (
                                                    <option key={p.id} value={p.id}>{p.name || p.email || p.id}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    )}
                                </div>
                                <h6 className="dropdown-header">Ações</h6>
                                {isTeacher ? (
                                    <>
                                        {canCreate && (
                                            <button className="dropdown-item" type="button" onClick={onNewTask}>
                                                <i className="fas fa-plus mr-2"></i> 
                                                {translate?.nova_tarefa || "Nova Tarefa"}
                                            </button>
                                        )}
                                        <button className="dropdown-item" type="button" onClick={onShowTemplates}>
                                            <i className="fas fa-copy mr-2"></i> 
                                            {translate?.usar_template || "Usar Template"}
                                        </button>
                                    </>
                                ) : (
                                    <button className="dropdown-item" type="button" onClick={onShowUserTasks}>
                                        <i className="fas fa-tasks mr-2"></i> 
                                        Minhas tarefas enviadas
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                    
                    {/* Mostrar filtros ativos à direita (segundo elemento) */}
                    <div className="d-flex flex-wrap">
                        {selectedUnit && (
                            <span className="badge badge-primary badge-sm mr-2 mb-2">
                                <i className="ni ni-building mr-1"></i>
                                {units.find(u => u.id === parseInt(selectedUnit))?.name}
                            </span>
                        )}
                        {selectedLesson && (
                            <span className="badge badge-info badge-sm mr-2 mb-2">
                                <i className="ni ni-book-bookmark mr-1"></i>
                                {lessons.find(l => l.id === parseInt(selectedLesson))?.name}
                            </span>
                        )}
                    </div>
                </div>
                
                {/* Exibir painel de filtros se estiver aberto */}
                {showFilters && (
                    <div className="mobile-filter-panel mb-3 p-3">
                        <div className="mb-2">
                            <label className="form-control-label d-flex align-items-center small">
                                <i className="ni ni-building mr-2"></i>
                                Unit
                            </label>
                            <Input
                                type="select"
                                value={selectedUnit}
                                onChange={onUnitChange}
                                className="form-control-alternative form-control-sm"
                                bsSize="sm"
                            >
                                <option value="">Todas as Units</option>
                                {units.map(unit => (
                                    <option key={unit.id} value={unit.id}>
                                        {unit.name}
                                    </option>
                                ))}
                            </Input>
                        </div>
                        
                        <div className="mb-2">
                            <label className="form-control-label d-flex align-items-center small">
                                <i className="ni ni-book-bookmark mr-2"></i>
                                Lesson
                            </label>
                            <Input
                                type="select"
                                value={selectedLesson}
                                onChange={onLessonChange}
                                className="form-control-alternative form-control-sm"
                                bsSize="sm"
                                disabled={!selectedUnit}
                            >
                                <option value="">Todas as Lessons</option>
                                {lessons.map(lesson => (
                                    <option key={lesson.id} value={lesson.id}>
                                        {lesson.name}
                                    </option>
                                ))}
                            </Input>
                        </div>

                        {(selectedUnit || selectedLesson) && (
                            <Button
                                color="link"
                                size="sm"
                                className="text-muted p-0 small"
                                onClick={() => {
                                    onUnitChange({ target: { value: '' } });
                                    onLessonChange({ target: { value: '' } });
                                }}
                            >
                                <i className="fas fa-times mr-1"></i>
                                Limpar filtros
                            </Button>
                        )}
                    </div>
                )}
            </div>

            {/* Barra de pesquisa - presente em ambas as versões */}
            <div className="filters-container mt-3">
                <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="fas fa-search" />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input
                        placeholder="Pesquisar tarefas..."
                        value={searchQuery}
                        onChange={onSearch}
                        className="form-control-alternative"
                    />
                </InputGroup>
            </div>
        </div>
    );
};

export default ModalTaskFilters;
